// Singleton
export class Setup {
  static API_BASE_PATH = '/api/vrs-documentshop-api/';
}
